import Lenis from "lenis";

let lenis = null;

export function initLenis() {
  if (lenis) return lenis;
  lenis = new Lenis({ duration: 1.15, smoothWheel: true });
  const raf = (t) => {
    lenis.raf(t);
    lenis._raf = requestAnimationFrame(raf);
  };
  lenis._raf = requestAnimationFrame(raf);
  return lenis;
}

export function scrollToTarget(target, offset = -1) {
  const el = typeof target === "string" ? document.querySelector(target) : target;
  if (!el) return;
  if (lenis) {
    lenis.scrollTo(el, { offset });
  } else {
    window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY + offset, behavior: "smooth" });
  }
}

export function scrollToY(y) {
  if (lenis) {
    lenis.scrollTo(y);
  } else {
    window.scrollTo({ top: y, behavior: "smooth" });
  }
}

export function destroyLenis() {
  if (!lenis) return;
  cancelAnimationFrame(lenis._raf);
  lenis.destroy();
  lenis = null;
}
